module.exports = __webpack_public_path__ + "img/logo2.362b0740.png";